module.exports = "/img/baby.d7f33da1.png";